import React from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import DualTableList from '../../../../components/DualTableList/DualTableList'
import { enhanceColumns } from '../../../../components/AgGrid/columnUtils'
import getFormValidations from './formValidations'
import { getListOptions, getDataLists, getLanguage, getEdit } from '../../selectors'

const DualTableListRedux = ({
    input: { value, onChange },
    objects,
    columns,
    originalObjectsById,
    path,
    leftBoxTKey,
    displayMode,
    disabled,
    required,
    height,
    t
}) => {
    const selected = Array.isArray(value) ? value.filter(o => !!o).map(o => o.id) : []

    return (
        <DualTableList
            objects={objects}
            selected={selected}
            columns={columns}
            path={path}
            leftBoxTKey={leftBoxTKey}
            displayMode={displayMode}
            disabled={disabled}
            required={required}
            height={height || 300}
            onChange={ids => onChange(ids.map(id => originalObjectsById[id]))}
            t={t}
        />
    )
}

const DualTableListLogic = ({ field, options, dataLists, language, accessId, t, objectMode }) => {
    const originalObjectsById = options.reduce((acc, o) => ({ ...acc, [o.id]: o }), {})

    const enhancedColumns = enhanceColumns(field.columns || [], {
        t,
        language,
        accessId,
        sortBy: null,
        sortDirection: null,
        dataLists
    })

    const validations = getFormValidations(field, t)

    return (
        <Field
            name={field.path}
            required={field.required}
            path={field.tKey || field.path}
            leftBoxTKey={field.leftBoxTKey || field.tKey || field.path}
            displayMode={field.displayMode}
            component={DualTableListRedux}
            objects={options}
            columns={enhancedColumns}
            originalObjectsById={originalObjectsById}
            disabled={field.disabled || !field.writable}
            height={field.height}
            validate={validations}
            t={t}
        />
    )
}

const mapStateToProps = (state, { field, t }) => ({
    options: getListOptions(state, field.id, field.sortList, field.translate, t),
    dataLists: getDataLists(state),
    language: getLanguage(state),
    accessId: getEdit(state).accessId
})

export default connect(mapStateToProps)(DualTableListLogic)